<script>
  import { cart } from '../models/cart.js'
  import { puzzlePack } from '../models/puzzlePack.js'
  import { onMount, beforeUpdate } from 'svelte'
  import { formatPrice } from '../services/utilities.js'

  export let product
  let added = false
  $: isInCart = $cart.some((c) => c.id === product.id)

  async function addItem(pp, product) {
    if (!puzzlePack.isInit()) {
      await cart.add(pp)
    } else {
      await cart.swapPuzzlePack(pp)
    }

    cart.add(product)
    added = $cart.some((c) => c.id === product.id)

    if (added) {
      setTimeout(() => {
        added = false
      }, 2500)
    }
  }
</script>

<style type="text/less">
  .puzzle-pack-options {
    display: flex;
  }

  .puzzle-pack-options button {
    white-space: normal;
  }
</style>

<h4 class="h4">One Time Rental</h4>
{#await $puzzlePack && $cart}
  Loading...
{:then}
  <p>
    With our Puzzle Pack, you can rent
    <b>
      {$puzzlePack.minRentalOption} or {$puzzlePack.maxRentalOption} puzzles at
      once
    </b>
    for a one time payment. Return them within 8 weeks. You can have two Puzzle
    Packs out at once, so you are never without a puzzle!
  </p>
  {#if added}
    <p class="cart-success">
      <svg class="icon">
        <use href="/icons.svg#check" />
      </svg>
      Added to Cart!
    </p>
  {:else}
    <div class="puzzle-pack-options">
      {#if isInCart}
        <button class="btn btn-expanded" on:click={cart.remove(product)}>
          <svg class="icon">
            <use href={'/icons.svg#clear'} />
          </svg>
          Remove from Cart
        </button>
      {:else if !puzzlePack.isInit()}
        {#each Object.keys($puzzlePack.options) as opt}
          <button
            class="btn puzzle-pack-btn"
            class:btn-plain={false}
            on:click={() => {
              addItem($puzzlePack.options[opt], product)
            }}>
            <svg class="icon">
              <use href={'/icons.svg#cart'} />
            </svg>
            {`Add ${$puzzlePack.options[opt].maxPuzzles} Count Puzzle Pack\n`}
            {formatPrice($puzzlePack.options[opt].price)}
          </button>
        {/each}
      {:else if puzzlePack.isInit()}
        {#each Object.keys($puzzlePack.options) as opt}
          {#if opt == $puzzlePack.selectedSku}
            <button
              class="btn puzzle-pack-btn"
              class:btn-plain={false}
              disabled={$puzzlePack.itemCount >= $puzzlePack.maxPuzzles}
              on:click={() => {
                addItem($puzzlePack.options[opt], product)
              }}>
              <svg class="icon">
                <use href={'/icons.svg#cart'} />
              </svg>
              {`Rent With ${$puzzlePack.options[opt].maxPuzzles} Count Puzzle Pack\n`}
              {formatPrice($puzzlePack.options[opt].price)}
            </button>
          {:else}
            <button
              class="btn puzzle-pack-btn"
              class:btn-plain={false}
              disabled={$puzzlePack.options[opt].maxPuzzles < $puzzlePack.itemCount}
              on:click={() => {
                addItem($puzzlePack.options[opt], product)
              }}>
              <svg class="icon">
                <use href={'/icons.svg#cart'} />
              </svg>
              {#if $puzzlePack.options[opt].maxPuzzles > $puzzlePack.maxPuzzles}
                Upgrade
              {:else}Downgrade{/if}
              {` to ${$puzzlePack.options[opt].maxPuzzles} Count Puzzle Pack\n`}
              {formatPrice($puzzlePack.options[opt].price)}
            </button>
          {/if}
        {/each}
      {/if}
    </div>
  {/if}
{/await}
